import FontAwesomeIcon from 'features/common/FontAwesomeIcon';

export enum ProductType {
  insight_full = 'insight_full',
  safety_prioritize = 'safety_prioritize',
  traffic_monitor = 'traffic_monitor',
  custom_dashboard = 'custom_dashboard',
}

export interface ProductInfo {
  product_type: ProductType;
  product_name: string;
  product_url: string;
  subscription_expired: boolean;
  org_id: string;
}

const ICON_SIZE = '32px';

export const PRODUCT_DETAILS = {
  [ProductType.insight_full]: {
    image: <FontAwesomeIcon name="traffic-light" size={ICON_SIZE} />,
  },
  [ProductType.safety_prioritize]: {
    image: <FontAwesomeIcon name="traffic-cone" size={ICON_SIZE} />,
  },
  [ProductType.traffic_monitor]: {
    image: <FontAwesomeIcon name="road-barrier" size={ICON_SIZE} />,
  },
  [ProductType.custom_dashboard]: {
    image: (
      <FontAwesomeIcon
        name="objects-column"
        size={ICON_SIZE}
        type="duotone-solid"
        sx={{ transform: 'rotate(90deg)' }}
      />
    ),
  },
};
